import { Suspense } from 'react';
import { CartSessionKeyProvider } from '@skin-seoul/service';
import { BMSMCampaignBanner } from '@skin-seoul/shared-components';
import { Skeleton, cn } from '@skin-seoul/design-system';

type BMSMCampaignBannerShortcodeProps = {
  className?: string;
  height?: number;
};

const DEFAULT_BANNER_HEIGHT = 116;

export const BMSMCampaignBannerShortcode = ({ className, height }: BMSMCampaignBannerShortcodeProps) => {
  const skeletonHeight = height ?? DEFAULT_BANNER_HEIGHT;
  return (
    <CartSessionKeyProvider>
      <Suspense
        fallback={
          <Skeleton className={cn('w-full rounded-2xl', className)} style={{ height: `${skeletonHeight}px` }} />
        }
      >
        <BMSMCampaignBanner className={className} height={height} />
      </Suspense>
    </CartSessionKeyProvider>
  );
};
